// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LoginForShopRequestModel from '../../model/login-for-shop-request-model';
import LoginForShopRequestDTO from '../dto/login-for-shop-request-dto';
import dtoSchema from '../schemas/login-for-shop-request-schema';

export default abstract class LoginForShopRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LoginForShopRequestDTO>) {
    super();
    if (data) {
      this.username = data.username ?? undefined;
      this.password = data.password ?? undefined;
    }
  }
  /**
  */
  username?: string;
  /**
  */
  password?: string;

  static toModel(dto: DeepPartial<LoginForShopRequestDTO>): LoginForShopRequestModel;
  static toModel(dto: DeepPartial<LoginForShopRequestDTO> | undefined | null): LoginForShopRequestModel | undefined;
  static toModel(dto: DeepPartial<LoginForShopRequestDTO> | undefined | null): LoginForShopRequestModel | undefined {
    return dto ? new LoginForShopRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LoginForShopRequestModel> | LoginForShopRequestModel): LoginForShopRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      username: unwrapped.username,
      password: unwrapped.password,
    } as LoginForShopRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LoginForShopRequestModel, can not map to LoginForShopRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
